// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"44f8d7e3","769":"72993ee5"}[chunkId] + ".chunk.css";
};